var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var LayoutColumn = function (_React$Component) {
  _inherits(LayoutColumn, _React$Component);

  function LayoutColumn() {
    _classCallCheck(this, LayoutColumn);

    return _possibleConstructorReturn(this, (LayoutColumn.__proto__ || Object.getPrototypeOf(LayoutColumn)).apply(this, arguments));
  }

  _createClass(LayoutColumn, [{
    key: 'render',
    value: function render() {
      var width = (this.props.width * 100).toPrecision(5) + '%';
      return React.createElement(
        'div',
        { className: 'cf-layout__column', style: { width: width } },
        this.props.children
      );
    }
  }]);

  return LayoutColumn;
}(React.Component);

LayoutColumn.propTypes = {
  width: PropTypes.number.isRequired,
  children: PropTypes.node
};

export default LayoutColumn;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-layout/es/LayoutColumn.js
// module id = 556
// module chunks = 0